import logo320 from "./assets/petsoul-logo-320w.webp";
import logo480 from "./assets/petsoul-logo-480w.webp";
import logo640 from "./assets/petsoul-logo-640w.webp";
import "./brand-logo.css";

/**
 * The supplied wordmark keeps its original colours and transparent artwork.
 * 体积（UI-REVIEW110-01）：原图 petsoul-logo.png 2172×724、约 480KB，页面上只显示 136–156px 宽；
 * 改用按显示尺寸等比缩出的三档（320／480／640，同一张图、颜色不动，来历见 assets/petsoul-logo-sizes-provenance.md），浏览器按屏幕倍数挑。
 */
export function BrandLogo({ size = "standard" }: {
  size?: "standard" | "welcome" | "compact";
}) {
  return (
    <span className={`ps-brand-logo ps-brand-logo--${size}`}>
      <img src={logo480} srcSet={`${logo320} 320w, ${logo480} 480w, ${logo640} 640w`} sizes={size === "compact" ? "136px" : "156px"} alt="PetSoul" width={480} height={160} decoding="async" />
    </span>
  );
}
